/* ==========================================================================
   tracking.js — Meta Pixel init + safe event helpers
   --------------------------------------------------------------------------
   No-op if SETTINGS.metaPixelId is null, so the page works while developing.
   All calls are wrapped so a blocked pixel never throws.
   ========================================================================== */

(function () {
  const { SETTINGS } = window.NATY;
  const pixelId = SETTINGS.metaPixelId;

  let initialized = false;

  // The standalone site did not have Shopify's consent state. On the theme,
  // defer marketing until the store's Customer Privacy API permits it.
  function allowed() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(pixelId && privacy && privacy.marketingAllowed() && privacy.saleOfDataAllowed());
  }

  function init() {
    if (initialized || !allowed()) return;
    initialized = true;
    // Standard Meta Pixel bootstrap.
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
      n.queue = []; t = b.createElement(e); t.async = !0;
      t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', pixelId);
    window.fbq('trackSingle', pixelId, 'PageView');
  }

  document.addEventListener('visitorConsentCollected', init);
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) init();
    });
  }
  init();
  function track(eventName, params = {}, isStandard = false) {
    try {
      if (!allowed()) return;
      init();
      if (window.fbq) {
        window.fbq(isStandard ? 'trackSingle' : 'trackSingleCustom', pixelId, eventName, params);
      }
    } catch (e) {
      /* never let analytics break the page */
    }
  }

  window.NATY.track = {
    amazonClick: (market) => {
      track('ClickAmazon', { market });
      track('Lead', { content_name: 'amazon_' + market }, true);
    },
    retailerClick: (market, retailer, type) =>
      track('ClickRetailer', { market, retailer, type }),
    switchMarket: (market) => track('SwitchMarket', { market }),
    mapSearch: (market, method) => track('MapSearch', { market, method }),
  };
})();
